
<template>
    <div style="background-color: #f0f2f5;" class="register-box">
        <el-menu class="el-menu-demo" router :default-active="this.$route.path" mode="horizontal" text-color="#333" active-text-color="#343951">
            
            <img class="logoimg" src="../../assets/img/logo.png" alt="" @click="goto1('/login')">

        </el-menu>
        
        <div style="display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 3%;" v-show="registVisible">
            <div class="content" style=" 
                height: 600px;
                background-color: white;">
                <!-- 主体内容 -->
                <div style="margin: 40px 20px;" class="text-center" >
                    <span style="font-size: larger; font-weight: 600;">欢迎注册</span>

                    <div style=" font-size: 14px;
                        color: #333;
                        cursor: pointer;" class="text-float">
                        <span>已有账号，</span>
                        <span><el-button type="text" @click="$router.push('/login')">去登陆<i class="el-icon-arrow-right"></i></el-button></span>
                    </div>
                    <el-divider class="divider" ></el-divider>
                </div>
                <!-- 表单 -->
                <div class="form-box">
                    <el-form class="form"  label-width="80px" :model="form" :rules="rules" ref="form">
                        <el-form-item label="" prop="nickname">
                            <el-input v-model="form.nickname" placeholder="设置用户名称"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <!-- <el-input v-model="form.password" placeholder="设置登录密码"></el-input> -->
                            <el-popover
                                placement="right"
                                width="200"
                                trigger="focus">
                                <!-- 密码规则 -->
                                <ul  class="mgt-xs">
                                <li  v-for="item in pwcheckArr" :key="item.index" :class="item.statusClass" style="font-size: 14px;">
                                    <div  style="display: flex;line-height: 20px;">
                                    <div  :class="item.statusIcon" style="font-size: 14px;padding-right: 5px;"></div>
                                    <div  class="mgl-xs">{{item.text}}</div>
                                    </div>
                                </li>
                                </ul>
                                <el-input slot="reference" v-model="form.password" show-password @input="passwordCheck"  placeholder="设置登录密码"></el-input>
                            </el-popover>
                        </el-form-item>
                        <el-form-item label="" prop="confirmPassword">
                            <el-input v-model="form.confirmPassword" show-password placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="mobile">
                            <el-input placeholder="+86" class="input-phone1" :disabled="true"></el-input>
                            <el-input v-model="form.mobile" placeholder="请再次11位手机号" class="input-phone2" ></el-input>
                        </el-form-item>
                            
                        <el-form-item>
                            <el-button type="danger" @click="submitForm" style="width:100%">注册</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        
        <div style="display: flex; justify-content: center; align-items: center;  padding-top: 3%;height: 700px;" v-show="!registVisible">
            <div style=" width: 70%;
                background-color: white;display: flex;
                height: 100%;
                justify-content: center;">
              <el-result icon="success" title="注册成功" >
                <template slot="extra">
                  <el-button type="primary" size="medium" @click="$router.push({path: '/'})">进入华万控制台</el-button>
                </template>
              </el-result>
            </div>
        </div>

    <FooterItem></FooterItem>

<!-- 手机验证弹框 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible" >
      <span>发送短信验证码到{{form.mobile}}</span>
      <el-input placeholder="验证码" v-model="form.captcha" class="captcha-input">
        <el-button slot="append" v-show="show" @click="getCaptcha" >发送验证码</el-button>
        <el-button slot="append" v-show="!show">{{count}} s</el-button>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>

  <!-- 人机验证       -->
    <transition name="fade">
      <jigsaw-captcha
        ref="captcha"
        v-if="captchaVisible"
        :show="captchaVisible"
        :register="registerCaptcha"
        :login="loginCaptcha"
        @close="onCloseCaptcha"
      ></jigsaw-captcha>
    </transition>


    </div>
</template>

<script>
// 导入组件
import JigsawCaptcha from '@/components/CaptchaJigsaw'
import FooterItem from '../../components/footer.vue'
import {signup,register,sendregister } from '@/api/userMG'
import Qs from 'qs';


// 导出模块
export default {
  // 模块名字
  name: "register",
  // 模块数据
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if(value.length<8){
          callback(new Error('密码至少8个字符'))
        }
        if(!(/[a-zA-Z]{1,}/.test(value))){
          callback(new Error('密码有至少1个字母(a, b, c...)'))
        }
        if(!(/\d{1,}/.test(value))){
          callback(new Error('有至少1个数字(1, 2, 3...)'))
        }
        if(!(/[A-Z]{1,}/.test(value)) || !(/[a-z]{1,}/.test(value))){
          callback(new Error('包含大写和小写字符'))
        }
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(`请输入手机号码`));
      }else {
        if(value.length!=11){
          callback(new Error('请输入11位手机号码'));
        }else if(!/^(13[0-9]|14[0-9]|15[0-9]|16[256]|17[01235678]|18[0-9]|19[0-9])\d{8}$/.test(value)){
          callback(new Error('请输入正确的手机号码'));
        }else{
          callback();
        }
      }
    };
    //数据  
    return {
        registVisible: true,
        timer: null,
        count: 0,
        show: true,
        dialogVisible: false,
        captchaVisible: false,
        form:{
            nickname: '',
            mobile: '',
            password: '',
            confirmPassword: '',
            captcha: '',
            sessionid: ''
        },
        rules: {
            nickname: [
                { required: true, message: '请输入名称', trigger: 'blur' },
            ],
            mobile: [
                { validator: validateMobile, trigger: 'blur' }
            ],
            password: [
                { validator: validatePass, trigger: 'blur' }
            ],
            confirmPassword: [
                { validator: validatePass2, trigger: 'blur' }
            ],
        },
        pwcheckArr: [
            {statusClass:'error', statusIcon:'zm-icon-dot', text: '有至少8个字符'},
            {statusClass:'error', statusIcon:'zm-icon-dot', text: '有至少1个字母(a, b, c...)'},
            {statusClass:'error', statusIcon:'zm-icon-dot', text: '有至少1个数字(1, 2, 3...)'},
            {statusClass:'error', statusIcon:'zm-icon-dot', text: '包含大写和小写字符'}
        ]
    };
  },
  // 注册组件
  components: {
    JigsawCaptcha,
    FooterItem
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {

    submitForm() {
      this.$refs['form'].validate(valid => {
            if(valid){
              console.log(this.form)
              this.dialogVisible = true
            }
        })
    },
    getCaptcha() {
      this.captchaVisible = true
    },

    /**
     * 注册验证码
     */
    registerCaptcha () {
      return new Promise((resolve, reject) => {
        register().then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * 拼图校验与登录
     */
    loginCaptcha (token, sliceX) {
      return new Promise((resolve, reject) => {
          // this.index++
          let form = {
            username: this.form.mobile,
            token: token,
            sliceX: sliceX
          }
          sendregister(form,0).then(resp => {
            resolve(resp)
            if(resp.code==0){
              this.$message.success('发送成功')
              //倒计时
              const TIME_COUNT = 60
              if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }
            }else{
              if(resp.code==1001){
                this.$message.warning(`请勿频繁发送短信`)
              }
            }
          }, err => {
            reject(err)
          })
        
      })
    },

    /**
     * 关闭弹出验证码
     */
    onCloseCaptcha () {
      this.captchaVisible = false
    },
    
    passwordCheck(value){
      console.log(value)
      if(value.length>=8){
          this.pwcheckArr[0].statusClass = 'success'
          this.pwcheckArr[0].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[0].statusClass = 'error'
          this.pwcheckArr[0].statusIcon = 'zm-icon-dot'
      }
      if(/[a-zA-Z]{1,}/.test(value)){
          this.pwcheckArr[1].statusClass = 'success'
          this.pwcheckArr[1].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[1].statusClass = 'error'
          this.pwcheckArr[1].statusIcon = 'zm-icon-dot'
      }
      if(/\d{1,}/.test(value)){
          this.pwcheckArr[2].statusClass = 'success'
          this.pwcheckArr[2].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[2].statusClass = 'error'
          this.pwcheckArr[2].statusIcon = 'zm-icon-dot'
      }
      if(/[A-Z]{1,}/.test(value) && /[a-z]{1,}/.test(value)){
          this.pwcheckArr[3].statusClass = 'success'
          this.pwcheckArr[3].statusIcon = 'zm-icon-checked'
      }else{
          this.pwcheckArr[3].statusClass = 'error'
          this.pwcheckArr[3].statusIcon = 'zm-icon-dot'
      }
    },
    onSubmit(){
      //调注册接口
      signup(this.form).then(res=>{
        if(res.code==0){
          this.dialogVisible = false
          this.registVisible = false
          
          this.$store.commit(`setToken`, res.data.token);
        }else if(res.code==1003){
          this.$message.error('注册失败：手机号码已被使用')
        }else{
          this.$message.error(res.message)
        }
      })
    }

  },
  mounted() {
    //获取地址栏参数pid
    const query = Qs.parse(location.search.substring(1))
    if(query.pid){
      this.$cookies.set('H-pid',query.pid,1800)
    }
  },
};
</script>
// scoped 样式只在本组件使用
<style>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
 @media only screen and (max-width: 500px) {
    
  .register-box .content{
    width: 90%;
  }
  .register-box .form{
    padding: 0 5% 0 5%;
  }
  .register-box .content .text-center{
    text-align: center; 
  }
  .register-box .el-form-item__content{
    margin-left: 0px !important;
  }
  .register-box .content .input-phone1{
    width: 20%;
  }
  .register-box .content .input-phone2{
    width: 78%;
  }
  .register-box .el-dialog{
    width: 80%;
  }
  

}
@media only screen and (min-width: 500px) {
    
    
  .register-box .content{
    width: 70%;
  }
  
  .register-box .content .text-float{
    float:right; 
  }
  
  
  .register-box .content .input-phone1{
    width: 15%;
  }
  .register-box .content .input-phone2{
    width: 84%;
  }

  .register-box .el-dialog{
    width: 20%;
  }
}
 .register-box .divider{
        margin: 14px 0 !important;
    }
.register-box .el-menu-demo {
    width: 100%;
    height: 50px;
    }
    
 .register-box .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    }

    .register-box .logoimg {
    height: 36px;
    position: absolute;
    top: 7px;
    /* left: 67px; */
    margin-left: 30px;
    }

    .register-box .txt1{
        margin-bottom: 10px;
        color: #333333;
        font-weight: normal;
        font-size: 14px;
    }
    .register-box .txt2{    
    color: #aeaeae;
        font-size: 13px;
    }
    .register-box .form-box{
        display: flex;
        justify-content: center;
    }

    
    .register-box .form{
        width: 500px;
    }

   
.mgt-xs {
    margin-top: 4px!important;
}
ul{
  
  list-style: none;
    padding-left: 0;

}
.error {
    color: #747487;
}
.zm-icon-dot:before {
    content: "\2022";
}
.zm-icon-checked:before {
    content: "\2714";
}
.success {
    color: #3c763d;
}
.captcha-input{
  padding-top: 10px;
}
.captcha-input .el-input-group__append{
  padding: 0 10px;
}
</style>

<style >
  

.geetest_box_logo,.geetest_feedback{
  display: none !important;
}
  .el-submenu__title i {
    display: none;
  }
  .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .el-submenu__title:hover {
    font-weight: bold;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  .el-menu--horizontal > .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
  .inputmenu .el-input__inner {
    border-radius: 3px;
  }
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #fff;
    border-bottom-color: #fff !important;
  }
  .el-button--info {
    color: #FFF;
    background-color: #dedede;
    border-color: #dedede;
    color: black;
}
.el-button--info {
    background-color: #8e9093;
    border-color: #8e9093;
    color: white;
}
.el-button--info:hover {
    background: #a6a9ad;
    border-color: #a6a9ad;
    color: #FFF;
}
  </style>


// WEBPACK FOOTER //
// src/views/login/register.vue